import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import HeaderSectionLeft from "./HeaderSectionLeft.jsx"
import HeaderSectionRight from "./HeaderSectionRight.jsx"
import CMSData from "aldoo-ra/CMS/cms-data"

const HeaderSection = () => {
  // SSR-fetched section renders the hero (LCP element) on the first client
  // pass instead of waiting for the client CMS fetch; CMSData takes over.
  const { homeHeroSection } = usePageContext()
  const ssrSection =
    homeHeroSection?.name === "WindowsHomeHeader" ? homeHeroSection : null

  //Load the data for the section from the CMS
  const { data } = CMSData({
    contentType: "PageSection",
    match: { "content.name": "WindowsHomeHeader" },
  })

  const section = data?.[0] || ssrSection
  if (!section) return null
  return (
    <div>
      <div className="relative flex flex-col md:flex-row w-full md:max-w-[900px] lg:max-w-[1060px] xl:max-w-[1530px] justify-between lg:items-end xl:items-start gap-16 md:gap-6 pt-8 xl:pt-0 px-6  lg:px-8 mx-auto">
        <HeaderSectionLeft data={section} />
        <HeaderSectionRight data={section} />
      </div>
    </div>
  )
}

export default HeaderSection
